/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AccountId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromViewsValidate from 'Simple/Data/validate'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function AccountId({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Bluefin/AccountId",
  onChange,
  isInvalid
  
}) {
let addProviderBluefinAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'bluefin.account_id',
})
let addProviderBluefinAccountIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'add_provider',
path: 'bluefin.account_id',
validate: fromViewsValidate.textAtLeastOneChar,
required: true,
})
let addProviderBluefinAccountIdChangeData = fromData.useDataChange({ viewPath,
context: 'add_provider',
path: 'bluefin.account_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginRight={dtSpaceS}
 label="Account ID"
 marginTop={0}
 marginBottom={0}
 backgroundColor={dtColorsWhite}
 data="add_provider.bluefin.account_id"
 value={addProviderBluefinAccountIdValueData}
 onChange={addProviderBluefinAccountIdChangeData}
 required={true}
 validate="textAtLeastOneChar"
 invalid={!addProviderBluefinAccountIdIsValidData}
/>
{children}
</React.Fragment>)
}